/**
 * What is done to a feature flag - the single vocabulary behind the confirmation dialog's
 * intent and the action recorded in the audit log, which are the same three cases.
 *
 * `Remove` is not derivable from the resulting state: removing an entry and enabling a flag
 * both end up at `true`, so only the recorded action tells a cleanup from a real activation.
 */
export enum FeatureFlagActionEnum {
  Enable = 'enable',
  Disable = 'disable',
  Remove = 'remove',
}
